import { Action } from '@ngrx/store';

// import { AvailableRuleItem, AvailableRuleEventCondition, RuleEvent, RuleListItem, RuleAction, RuleCondition } from '@app/models/rules';
import * as fromRulesModel from '@app/models/rules';


export enum SettingsRulesActionType {
    // PERSISTED RULES ACTIONS
    LoadRules = "[SettingsRules] GET - Obtain all persisted rules events",
	LoadRulesSuccess = "[SettingsRules] - Obtain all persisted rules events SUCCESS",
	LoadRulesError = "[SettingsRules] - Obtain all persisted rules events ERROR",

    SetActiveRule = "[SettingsRules] - PUT set active property of rule",
	SetActiveRuleSuccess = "[SettingsRules] - set active property of rule SUCCESS",
	SetActiveRuleError = "[SettingsRules] - set active property of rule ERROR",

	LoadRule = "[SettingsRules] - GET load persisted rule event",
	LoadRuleSuccess = "[SettingsRules] - load persisted rule event SUCCESS",
	LoadRuleError = "[SettingsRules] - load persisted rule event ERROR",

	// EVENT CALLS
	LoadAvailableEvents = "[SettingsRules] GET - Obtain all available rule events",
	LoadAvailableEventsSuccess = "[SettingsRules] - Obtain all available events SUCCESS",
	LoadAvailableEventsError = "[SettingsRules] - Obtain all available events ERROR",

	LoadAvailableConditions = "[SettingsRules] GET - Obtain all available event conditions",
	LoadAvailableConditionsSuccess = "[SettingsRules] - Obtain all available event conditions SUCCESS",
	LoadAvailableConditionsError = "[SettingsRules] - Obtain all available event conditions ERROR",

	LoadAvailableActions = "[SettingsRules] GET - Obtain all available event actions",
	LoadAvailableActionsSuccess = "[SettingsRules] - Obtain all available event actions SUCCESS",
	LoadAvailableActionsError = "[SettingsRules] - Obtain all available event actions ERROR",

	ClearRule = "[SettingsRules] - clear editing rule",

    SetRuleDescription = "[SettingsRules] - set rule description in editing rule",
    SetRuleConditionsControl = "[SettingsRules] - set event condition control in editing rule",

    SetRuleConditionsFormTerm = "[SettingsRules] - set condition form term in editing rule forms",
    SetRuleActionsFormTerm = "[SettingsRules] - set action form term in editing rule forms",

    SetRuleEvent = "[SettingsRules] - set event element in editing rule", // for load persisted rule automatic
    UpdateRuleEvent = "[SettingsRules] - user update the event key in the editing rule form", // for user updating the rule event
    RuleEventChangedSuccess = "[SettingsRules] - changed the event key in editing rule SUCCESS", // common action for set values in rule
    CheckAvailableConditions = "[SettingsRules] - check if current set event conditions are loaded ",
    CheckAvailableActions = "[SettingsRules] - check if current set event actions are loaded ",
    

    AddRuleAction = "[SettingsRules] - add new rule action in editing current rule and its forms",
    ChangeRuleAction = "[SettingsRules] - change rule action parameters in editing rule",
    ChangeRuleActionKey = "[SettingsRules] - change rule action key in editing rule",
    RemoveRuleAction = "[SettingsRules] - remove rule action in editing rule",

    AddRuleCondition = "[SettingsRules] - add new rule condition in editing rule",
    ChangeRuleCondition = "[SettingsRules] - change existing rule condition in editing rule",
    ChangeRuleConditionValues = "[SettingsRules] - change existing rule condition variable in editing rule",
    RemoveRuleCondition = "[SettingsRules] - remove rule condition in editing rule and its associated form",

    SaveRule = "[SettingsRules] - save editing rule",
    UpdateRule = "[SettingsRules] PUT - save editing rule",
    CreateRule = "[SettingsRules] POST - save editing rule",
    SaveRuleSuccess = "[SettingsRules] - save editing rule SUCCESS",
    SaveRuleError = "[SettingsRules] - save editing rule ERROR",

    SetEditSelectScroll = "[SettingsRules] - save editing multiselect scroll"
}

// Load persisted rules list
export class LoadRules implements Action {
    readonly type = SettingsRulesActionType.LoadRules;
    constructor() {}
}

export class LoadRulesSuccess implements Action {
    readonly type = SettingsRulesActionType.LoadRulesSuccess;
    constructor(public rules: fromRulesModel.RuleListItem[]) {}
}

export class LoadRulesError implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableActionsError;
    constructor() {}
}

// active / deactive actions for persisted rules
export class SetActiveRule implements Action {
    readonly type = SettingsRulesActionType.SetActiveRule;
    constructor(public ruleId: number, public active: boolean) {}
}

export class SetActiveRuleSuccess implements Action {
    readonly type = SettingsRulesActionType.SetActiveRuleSuccess;
    constructor() {}
}

export class SetActiveRuleError implements Action {
    readonly type = SettingsRulesActionType.SetActiveRuleError;
    constructor(public ruleId: number, public active: boolean) {}
}

export class LoadRule implements Action {
    readonly type = SettingsRulesActionType.LoadRule;
    constructor(public ruleId: number) {}
}

export class LoadRuleSuccess implements Action {
    readonly type = SettingsRulesActionType.LoadRuleSuccess;
    constructor(public rule: fromRulesModel.RuleEvent) {}
}

export class LoadRuleError implements Action {
    readonly type = SettingsRulesActionType.LoadRuleError;
    constructor() {}
}

// Load Available Events
export class LoadAvailableEvents implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableEvents;
    constructor() {}
}
export class LoadAvailableEventsSuccess implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableEventsSuccess;
    constructor(public events: fromRulesModel.AvailableRuleEventElement[]) {}
}
export class LoadAvailableEventsError implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableEventsError;
    constructor() {}
}

// Load Available Event Conditions
export class LoadAvailableConditions implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableConditions;
    constructor(public eventKey: string) {}
}
export class LoadAvailableConditionsSuccess implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableConditionsSuccess;
    constructor(public eventKey: string, public conditions: fromRulesModel.AvailableRuleEventCondition[]) {}
}
export class LoadAvailableConditionsError implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableConditionsError;
    constructor() {}
}

// Load available Event Actions
export class LoadAvailableActions implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableActions;
    constructor(public actionItem: fromRulesModel.AvailableRuleItem) {}
}

export class LoadAvailableActionsSuccess implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableActionsSuccess;
    constructor(public actionItem: fromRulesModel.AvailableRuleItem, public actions: fromRulesModel.AvailableRuleActionVariable[]) {}
}

export class LoadAvailableActionsError implements Action {
    readonly type = SettingsRulesActionType.LoadAvailableActionsError;
    constructor() {}
}

export class ClearRule implements Action {
    readonly type = SettingsRulesActionType.ClearRule;
    constructor() {}
}

export class SetRuleEvent implements Action {
    readonly type = SettingsRulesActionType.SetRuleEvent;
    constructor(public eventKey: string) {}
}

export class UpdateRuleEvent implements Action {
    readonly type = SettingsRulesActionType.UpdateRuleEvent;
    constructor(public eventKey: string) {}
}

export class RuleEventChangedSuccess implements Action {
    readonly type = SettingsRulesActionType.RuleEventChangedSuccess;
    constructor(public eventKey: string) {}
}

export class CheckAvailableConditions implements Action {
    readonly type = SettingsRulesActionType.CheckAvailableConditions;
    constructor(public conditions: fromRulesModel.AvailableRuleItem[]) {}
}

export class CheckAvailableActions implements Action {
    readonly type = SettingsRulesActionType.CheckAvailableActions;
    constructor(public actions: fromRulesModel.AvailableRuleItem[]) {}
}


export class SetRuleDescription implements Action {
    readonly type = SettingsRulesActionType.SetRuleDescription;
    constructor(public description: string) {}
}

export class SetRuleConditionsControl implements Action {
    readonly type = SettingsRulesActionType.SetRuleConditionsControl;
    constructor(public control: string) {}
}

export class SetRuleConditionsFormTerm implements Action {
    readonly type = SettingsRulesActionType.SetRuleConditionsFormTerm;
    constructor(public form: fromRulesModel.AvailableRuleItemForm, public term: string) {}
}

export class SetRuleActionsFormTerm implements Action {
    readonly type = SettingsRulesActionType.SetRuleActionsFormTerm;
    constructor(public form: fromRulesModel.AvailableRuleItemForm, public key: string, public term: string) {}
}

export class AddRuleAction implements Action {
    readonly type = SettingsRulesActionType.AddRuleAction;
    constructor() {}
}

export class ChangeRuleAction implements Action {
    readonly type = SettingsRulesActionType.ChangeRuleAction;
    constructor(public action: fromRulesModel.RuleAction) {}
}

export class ChangeRuleActionKey implements Action {
    readonly type = SettingsRulesActionType.ChangeRuleActionKey;
    constructor(public action: fromRulesModel.RuleAction) {}
}

export class RemoveRuleAction implements Action {
    readonly type = SettingsRulesActionType.RemoveRuleAction;
    constructor(public formId: string) {}
}

export class AddRuleCondition implements Action {
    readonly type = SettingsRulesActionType.AddRuleCondition;
    constructor() {}
}

export class ChangeRuleCondition implements Action {
    readonly type = SettingsRulesActionType.ChangeRuleCondition;
    constructor(public condition: fromRulesModel.RuleCondition) {}
}

export class ChangeRuleConditionValues implements Action {
    readonly type = SettingsRulesActionType.ChangeRuleConditionValues;
    constructor(public condition: fromRulesModel.RuleCondition) {}
}

export class RemoveRuleCondition implements Action {
    readonly type = SettingsRulesActionType.RemoveRuleCondition;
    constructor(public formId: string) {}
}

export class SaveRule implements Action {
    readonly type = SettingsRulesActionType.SaveRule;
    constructor() {}
}

export class CreateRule implements Action {
    readonly type = SettingsRulesActionType.CreateRule;
    constructor(public rule: fromRulesModel.RuleEvent) {}
}

export class UpdateRule implements Action {
    readonly type = SettingsRulesActionType.UpdateRule;
    constructor(public id: number, public rule: fromRulesModel.RuleEvent) {}
}

export class SaveRuleSuccess implements Action {
    readonly type = SettingsRulesActionType.SaveRuleSuccess;
    constructor(public rule: fromRulesModel.RuleEvent) {}
}

export class SaveRuleError implements Action {
    readonly type = SettingsRulesActionType.SaveRuleError;
    constructor() {}
}

export class SetEditSelectScroll implements Action {
    readonly type = SettingsRulesActionType.SetEditSelectScroll;
    constructor(public key: string, public scroll: number) {}
}

export type SettingsRulesActions = 	LoadRules |
                                    LoadRulesSuccess |
                                    LoadRulesError |

                                    SetActiveRule |
                                    SetActiveRuleSuccess |
                                    SetActiveRuleError |

                                    LoadRule |
                                    LoadRuleSuccess |
                                    LoadRuleError |

                                    LoadAvailableEvents |
									LoadAvailableEventsSuccess |
									LoadAvailableEventsError |

									LoadAvailableConditions |
									LoadAvailableConditionsSuccess |
									LoadAvailableConditionsError |

									LoadAvailableActions |
									LoadAvailableActionsSuccess |
									LoadAvailableActionsError |

									ClearRule |

                                    SetRuleEvent |
                                    UpdateRuleEvent | 
                                    RuleEventChangedSuccess | 
                                    CheckAvailableConditions |
                                    CheckAvailableActions |

                                    SetRuleDescription |
                                    SetRuleConditionsControl |

                                    SetRuleConditionsFormTerm |
                                    SetRuleActionsFormTerm |

                                    AddRuleAction |
                                    ChangeRuleAction |
                                    ChangeRuleActionKey |
                                    RemoveRuleAction |

                                    AddRuleCondition |
                                    ChangeRuleCondition |
                                    ChangeRuleConditionValues |
                                    RemoveRuleCondition |

                                    SaveRule |
                                    UpdateRule |
                                    CreateRule |
                                    SaveRuleSuccess |
                                    SaveRuleError |

                                    SetEditSelectScroll
									;
